import useScrollReveal from '@/hooks/useScrollReveal';
import styles from './index.module.scss';

export interface FeatureRowProps {
  title: string;
  description: string;
  visualBackground: string;
  image: string;
  reverse?: boolean;
}

export default function FeatureRow({
  title,
  description,
  visualBackground,
  image,
  reverse = false,
}: FeatureRowProps) {
  const { ref, revealProps } = useScrollReveal<HTMLDivElement>();

  return (
    <div ref={ref} className={`${styles.row} ${reverse ? styles.reverse : ''}`} {...revealProps}>
      <div className={styles.text}>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.description}>{description}</p>
      </div>
      <div className={styles.visual} style={{ background: visualBackground }}>
        <img src={image} alt={title} className={styles.visualImage} loading="lazy" />
      </div>
    </div>
  );
}
